"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPropertyValueProperty = exports.propertyValuePropertyDefinition = void 0;
exports.propertyValuePropertyDefinition = {
    view: { label: 'Value' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'property-value',
};
const isPropertyValueProperty = (prop) => {
    return prop.name === exports.propertyValuePropertyDefinition.name;
};
exports.isPropertyValueProperty = isPropertyValueProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvcGVydHktdmFsdWUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9wcm9wZXJ0eS12YWx1ZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUU7SUFDeEIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGdCQUFnQjtDQUNTLENBQUE7QUFJMUIsTUFBTSx1QkFBdUIsR0FBRyxDQUFDLElBQWtCLEVBQWlDLEVBQUU7SUFDM0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHVDQUErQixDQUFDLElBQUksQ0FBQTtBQUMzRCxDQUFDLENBQUE7QUFGWSxRQUFBLHVCQUF1QiwyQkFFbkMifQ==